import * as React from 'react';

import type { DataTableAppearance } from './types';

const DataTableAppearanceContext =
  React.createContext<DataTableAppearance>('default');

export const DataTableAppearanceProvider = DataTableAppearanceContext.Provider;

export const useDataTableAppearance = () =>
  React.useContext(DataTableAppearanceContext);
